export default __webpack_public_path__ + "static/media/03_prorezavka-min.c3d49cce.jpg";